import { unparse, UnparseConfig } from 'papaparse';

interface IBuildAndDownloadCSVParams<TData> {
  exportData: TData[];
  name: string;
  config?: UnparseConfig;
}

// eslint-disable-next-line import/prefer-default-export
export const buildAndDownloadCSV = <TData>(params: IBuildAndDownloadCSVParams<TData>) => {
  const { exportData, name, config } = params;
  const csv = unparse(exportData, config);
  const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const csvURL = window.URL.createObjectURL(csvData);
  const downloadCSVElement = document.createElement('a');
  downloadCSVElement.href = csvURL;
  downloadCSVElement.download = `${name}.csv`;
  downloadCSVElement.click();
};
